const list = document.querySelector('.team-list');
if (list) {
    list.querySelectorAll('.is-accordion-title').forEach(title => {
        title.addEventListener('click', () => {
            if (!title.classList.contains('is-active')) {
                list.querySelectorAll('.is-active').forEach(active => {
                    active.classList.remove('is-active');
                });
            }

            title.classList.toggle('is-active');
            title.nextElementSibling.classList.toggle('is-active');

            if (window.innerWidth < 1024 && title.classList.contains('is-active')) {
                setTimeout(() => {
                    title.scrollIntoView();
                }, 500)
            }
        })
    })
}